import { Trans } from '@lingui/macro'
import { ButtonSecondary } from 'components/Button'
import { AutoRow } from 'components/Row'
import styled from 'styled-components/macro'

const Button = styled(ButtonSecondary).attrs(() => ({
  padding: '8px',
  $borderRadius: '8px',
}))`
  color: ${({ theme }) => theme.textPrimary};
  flex: 1;
`

interface PresetsButtonsProps {
  onSetFullRange: () => void
}

export default function PresetsButtons({ onSetFullRange }: PresetsButtonsProps) {
  return (
    <AutoRow gap="4px" width="auto">
      <Button onClick={onSetFullRange}>
        <Trans>Full Range</Trans>
      </Button>
    </AutoRow>
  )
}
